import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import moment from "moment";
import { getLanguages, getLoggedDevices, saveProfile, updateSubscriber, unsubscribeFromTopic, subscribeToTopic } from "../../../Api/api";
import { ANALYTICS_EVENTS, LOCAL_STORAGE_KEY } from "../../../constant";
import { utility } from "../../../utility/utility";
import MyButton from "./myButton";
import { getSubscriber, removeDevice } from "../../../Api/api";
import LogoutConfirmationBox from "./LogoutConfirmationBox";
import { useNavigate } from "react-router";
import RoundButtonWeb from "./RoundButtonWeb";
import RemoveDeviceConfirmationBoxWeb from "./RemoveDeviceConfirmationBoxWeb";
import { toast } from "react-toastify";
import { resetApplication } from "../../../redux/applicationSlice";
import { useDispatch } from "react-redux";
import { subscribeTopics, subscribeUserToTopics, unsubscribeTopics } from "../../../firebase/firebaseHelper";
import AnalyticsManager from "../../../analytics/analyticsManager";

const ProfileWeb = ({ open, onClose }) => {
    let user = utility.getValue(LOCAL_STORAGE_KEY.user);
    const [devices, setDevices] = useState([]);
    const [subscriber, setSubscriber] = useState({});
    const [editName, setEditName] = useState(false);
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showRemoveDeviceDialog, setShowRemoveDeviceDialog] = useState({ show: false, device: null });
    const [ipAddress, setIpAddress] = useState("");
    const dispatch = useDispatch();
    const [language, setLanguage] = useState("");
    const [languageList, setLanguageList] = useState([]);
    const [editLanguage, setEditLanguage] = useState(false);


    const greenDotStyle = {
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: '#00ff00',
        marginRight: '8px',
        animation: 'blinker 2s infinite',
    };

    const getIpAddress = async () => {
        const ipaddressRes = await fetch('https://api.ipify.org?format=json');
        const ipaddress = await ipaddressRes.json().then((data) => data['ip']);
        setIpAddress(ipaddress);
    }

    useEffect(() => {
        if (open) {
            getDevices();
            getUpdatedSubscriber();
            getIpAddress();
            loadCombo();
        }
    }, [open]);

    const loadCombo = async () => {
        let res = await getLanguages();
        if (res.success) {
            setLanguageList(res.data);
        }
        else {
            toast.error("Error fetching languages");
        }
    }

    const getDevices = async () => {
        try {
            const res = await getLoggedDevices(user?._id);
            setDevices(res.data || []);
        } catch (err) {
            console.error("Error fetching devices", err);
            toast.error("Error fetching devices");
        }
    };

    const getUpdatedSubscriber = async () => {
        try {
            setIsLoading(true);
            const res = await getSubscriber(user?.RMN);
            setSubscriber(res.data || {});
            setName(res.data?.Name ?? "");
            setLanguage(res.data?.Profiles?.[0]?.Language?.SID ?? "");
            setIsLoading(false);
        } catch (err) {
            toast.error("Error fetching subscriber");
            console.error("Error fetching subscriber", err);
            setIsLoading(false);
        }
    };

    const updateSubscriberName = async () => {
        try {
            const res = await updateSubscriber(user?._id, name, user?.Email);
            if (res.success) {
                // Analytics event
                AnalyticsManager().logEvent(ANALYTICS_EVENTS.LANGUAGE_CHANGE, {...user, Name: name});
                user.Name = name;
                utility.setValue(LOCAL_STORAGE_KEY.user, user);
            } else {
                setName(user?.Name ?? "");
            }
        } catch (err) {
            console.error("Error fetching subscriber", err);
        }
    };

    const updateSubscriberLanguage = async () => {
        const oldLanguage = subscriber?.Profiles[0]?.Language?.Description;
        const lang = languageList.find((l) => String(l.SID) === String(language));
        const updatedProfile = { ...subscriber?.Profiles[0], Language: lang };
        const res = await saveProfile(updatedProfile);
        if (res.success) {
            console.log(res);
            await unsubscribeTopics([oldLanguage]);
            await subscribeTopics([res?.data?.Language?.Description]);
            // Analytics event
            AnalyticsManager().logEvent(ANALYTICS_EVENTS.LANGUAGE_CHANGE, user);
            // utility.setValue(LOCAL_STORAGE_KEY.language, editedProfile?.Language ?? null);
        } else {
            toast.error("Error updating language");
        }
    }

    const handleUpdate = async () => {
        if (!editName && !editLanguage) {
            setEditName(true);
            setEditLanguage(true);
            return;
        }
    
        if (editName) {
            await updateSubscriberName();
        }
        if (editLanguage) {
            await updateSubscriberLanguage();
        }

        setEditName(false);
        setEditLanguage(false);
    };
    


    const handleUpgrade = () => {
        // Analytics event
        AnalyticsManager().logEvent(ANALYTICS_EVENTS.UPGRADE_PLAN, user);
        navigate('/plansweb');
    };

    const handleRemoveDevice = async (device) => {
        try {
            // Analytics event
            AnalyticsManager().logEvent(ANALYTICS_EVENTS.DEVICE_REMOVED, {...user, device: device.serialNumber});
            // If removing current device, log out after removal
            if (ipAddress === device.serialNumber) {
                let res = await removeDevice(user._id, device.serialNumber);
                if (res.success) {
                    utility.clearLocalStorage();
                    dispatch(resetApplication());
                    navigate('/loginWeb');
                }
                return;
            }

            // Otherwise just remove the device
            let res = await removeDevice(user._id, device.serialNumber);
            if (res.success) {
                getDevices();
                setShowRemoveDeviceDialog({ show: false, device: null });
            }
        } catch (err) {
            console.error("Error removing device:", err);
            toast.error("Error removing device");
        }
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                style: {
                    zIndex: 1400,
                    backgroundColor: "#140D24",
                    color: "white",
                    borderRadius: "12px",
                    padding: "20px",
                },
            }}
        >
            {/* Close Button */}
            <IconButton
                onClick={onClose}
                sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
            >
                <i className="fa fa-times" style={{ fontSize: "24px" }} />
            </IconButton>

            {/* Title */}
            <DialogTitle>
                <Typography variant="h6" fontWeight="bold" textAlign="center">
                    Profile
                </Typography>
            </DialogTitle>

            {/* Content */}
            <DialogContent dividers sx={{ color: "white", padding: "24px" }}>
                {/* Plan Info */}
                <div style={{ marginBottom: "24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {/* Left Side: Active Plan Info */}
                    <div>
                        <Typography variant="subtitle1" fontWeight="bold" fontSize={18}>
                            Active Plan: {subscriber?.PaymentPlan?.length > 0 ? subscriber?.PaymentPlan[0]?.Description : "No Active Plan"}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            Next payment on: {subscriber?.PaymentPlan?.length > 0
                                ? moment(subscriber?.PaymentPlan[0]?.ExpiryDate).utc().format("DD MMM, YYYY")
                                : "No Active Plan"}
                        </Typography>
                        {(subscriber?.PaymentPlan?.length > 0 && subscriber?.PaymentPlan[0]?.deviceLimit) && <Typography variant="body2" sx={{ mt: 1 }}>
                            Device Limit: {subscriber?.PaymentPlan[0]?.deviceLimit}
                        </Typography>}
                    </div>

                    {/* Right Side: Buttons */}
                    {!subscriber?.PaymentPlan?.length > 0 &&
                        <div style={{ display: "flex", gap: "10px" }}>
                            <MyButton title="Upgrade" openExitDialogue={handleUpgrade} />
                        </div>
                    }
                </div>

                {/* User Info */}
                <div style={{ marginBottom: "24px" }}>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        User Information:
                    </Typography>
                    <div
                        style={{
                            marginTop: "8px",
                            border: "1px solid #ffffff33",
                            borderRadius: "8px",
                            padding: "16px",
                            display: "flex",
                            flexDirection: "column",
                            gap: "16px",
                        }}
                    >
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginLeft: "50px" }}>
                            <Typography variant="body1" style={{ flex: 1 }}>
                                <strong>Mobile:</strong>{" "}
                                {subscriber?.RMN?.length > 1
                                    ? subscriber.RMN[0] + "*".repeat(subscriber.RMN.length - 2) + subscriber.RMN[subscriber.RMN.length - 1]
                                    : subscriber?.RMN || "N/A"}
                            </Typography>
                            <Typography variant="body1" style={{ flex: 1 }}>
                                <strong>Email:</strong> {subscriber?.Email || "N/A"}
                            </Typography>
                        </div>
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginLeft: "50px" }}>
                            <Typography variant="body1" style={{ flex: 1 }}>
                                <strong>Name:</strong> <input
                                    disabled={!editName}
                                    style={{
                                        width: '70%',
                                        padding: editName ? '6px' : '0px',
                                        marginLeft: editName ? "6px" : "0px",
                                        fontSize: '14px',
                                        backgroundColor: editName ? "#15181F" : "transparent",
                                        color: '#fff',
                                        border: editName ? '1px solid #707A94' : 'none',
                                        borderRadius: '10px'
                                    }} value={name} type="text" maxLength={20} onChange={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        setName(e.target.value)
                                    }} />
                            </Typography>
                            <Typography variant="body1" style={{ flex: 1 }}>
                                <strong>Region:</strong> {subscriber?.Region?.Description || "N/A"}
                            </Typography>
                        </div>
                        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", marginLeft: "50px" }}>
                            <Typography variant="body1" style={{ flex: 1 }}>
                                <strong>Language:</strong>{" "}
                                {!editLanguage ? (
                                    languageList.find((l) => String(l.SID) === String(language))?.Description || language || "N/A"
                                ) : (
                                    <select
                                        value={language}
                                        onChange={(e) => setLanguage(e.target.value)}
                                        style={{
                                            width: '25%',
                                            padding: '6px',
                                            marginLeft: '6px',
                                            fontSize: '14px',
                                            backgroundColor: "#15181F",
                                            color: '#fff',
                                            border: '1px solid #707A94',
                                            borderRadius: '10px'
                                        }}
                                    >
                                        <option value="">Select Language</option>
                                        {languageList.map((lang) => (
                                            <option key={lang.SID ?? lang._id} value={lang.SID ?? lang._id}>
                                                {lang.Description}
                                            </option>
                                        ))}

                                    </select>
                                )}
                            </Typography>
                        </div>

                        <div style={{ alignSelf: "flex-end" }}>
                            {isLoading ? <i className="fa fa-spinner fa-spin" /> : <RoundButtonWeb icon={!editName && !editLanguage ? "edit" : "check"} onClick={handleUpdate} />}

                        </div>
                    </div>
                </div>



                {/* Logged In Devices */}
                <div>
                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Logged In Devices:
                    </Typography>

                    {devices.length === 0 ? (
                        <Typography variant="body2" sx={{ color: "#aaa" }}>
                            No active devices found.
                        </Typography>
                    ) : (
                        devices.map((device, index) => (
                            <div
                                key={index}
                                style={{
                                    marginBottom: "12px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    border: "1px solid #ffffff33",
                                    borderRadius: "8px",
                                    padding: "12px",
                                }}
                            >
                                <div>
                                    {/* <Typography variant="body1">{device?.deviceName ?? ""}</Typography> */}
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                        <Typography variant="body1">{device?.deviceName ?? ""}</Typography>
                                        {ipAddress === device.serialNumber && <div style={greenDotStyle}></div>}
                                    </div>
                                    <Typography variant="caption" sx={{ color: "#ccc" }}>
                                        Last Login: {device?.lastLoginTime ? moment(device?.lastLoginTime).utc().format("DD MMM, YYYY") : ""}
                                    </Typography>
                                </div>
                                <RoundButtonWeb icon="delete" onClick={() => setShowRemoveDeviceDialog({ show: true, device: device })} />
                            </div>
                        ))
                    )}
                </div>
            </DialogContent>
            <RemoveDeviceConfirmationBoxWeb openRemoveDialog={showRemoveDeviceDialog.show} onCloseRemoveDialog={() => setShowRemoveDeviceDialog({ show: false, device: null })} device={showRemoveDeviceDialog.device} onConfirmRemove={handleRemoveDevice} />
        </Dialog>
    );
};

export default ProfileWeb;
